export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11772.f0ffe48c.jpg";